import { MouseEvent, ReactNode } from 'react'

export type NotificationType = {
  action?: ReactNode
  className?: string
  dismissable?: boolean
  icon?: boolean
  message: string
  onDismiss?: (event: MouseEvent) => void
  size?: 'sm' | 'base' | 'lg' | 'full'
  title: string
  toast?: boolean
  variant?: 'warn' | 'danger' | 'success' | 'info'
}
type NotificationListener = (params: NotificationType, timeout?: number) => void

let notificationListener: NotificationListener | undefined

const addListener = (listener: NotificationListener): void => {
  notificationListener = listener
}

const notify = (params: NotificationType, timeout?: number): void => {
  if (notificationListener) {
    notificationListener(params, timeout)
  }
}

/**
 * Service to allow showing notifications anywhere without the need of adding a new component.
 * The listener will always be attached to the application and devs only need to call .notify(...)
 * with the correct params to show a notification
 */
export const NotificationService = {
  addListener,
  notify,
}
